"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _parser = _interopRequireDefault(require("./parser"));

var _elementaryStream = _interopRequireDefault(require("./elementary-stream"));

var _accessUnit = _interopRequireDefault(require("./access-unit"));

var _adts = _interopRequireDefault(require("./adts"));

var _mpegParser = require("../mpeg-parser");

var bytes = _interopRequireWildcard(require("../../../helpers/byte-helpers"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var TransportStream =
/*#__PURE__*/
function () {
  _createClass(TransportStream, null, [{
    key: "parse",
    value: function parse(arrayBuffer) {
      var parser = new _parser.default();
      var stream = new TransportStream();
      var packetSize = detectPacketSize(arrayBuffer.slice(0, 205));

      for (var i = 0; i < arrayBuffer.length; i += packetSize) {
        var packet = parser.parse(arrayBuffer.slice(i, i + packetSize));

        if (packet) {
          stream.packets.push(packet);
        }
      }

      return stream;
    }
  }]);

  function TransportStream() {
    _classCallCheck(this, TransportStream);

    this.packets = [];
  }

  _createClass(TransportStream, [{
    key: "codecs",
    get: function get() {
      return this.trackPackets.filter(function (t) {
        return t.streamType === 27 || t.streamType === 15;
      }).map(function (p) {
        return p.codec;
      });
    }
  }, {
    key: "codecsString",
    get: function get() {
      return (0, _mpegParser.createCodecsString)(this.codecs);
    }
  }, {
    key: "PMT",
    get: function get() {
      return this.packets.filter(function (p) {
        return p.objType == 'PMT';
      })[0];
    }
  }, {
    key: "trackPackets",
    get: function get() {
      var _this = this;

      return this.PMT.programs[0].tracks.map(function (t, idx) {
        return _elementaryStream.default.parse(_this, t.streamType, idx + 1);
      });
    }
  }, {
    key: "tracks",
    get: function get() {
      return this.trackPackets.map(function (stream) {
        if (stream.streamType === 27) {
          return _accessUnit.default.parse(stream);
        }

        if (stream.streamType === 15) {
          return _adts.default.parse(stream);
        }

        return {};
      });
    }
  }]);

  return TransportStream;
}();

var detectPacketSize = function detectPacketSize(front) {
  for (var i = 0; i < front.length; i++) {
    var b = front[i];

    if (b === 0x47 && i >= 188) {
      return i;
    }
  }
};

var _default = TransportStream;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@krad/plainview/node_modules/@krad/slugline/distribution/parsers/container/ts/transport-stream.js
// module id = 204
// module chunks = 0